import { useEffect, useState } from 'react'
import { CurrentUser } from '../../model/Common/common.interface'
import { IS_DEVELOPMENT } from '../../modules/envVars'
import { BRAZE_STUDENT_WEB_KEY_PROD, BRAZE_STUDENT_WEB_KEY_QA } from '../../modules/vars'
import useBrazeStore from '../../store/useBrazeStore'

interface CsrOnlyStudentBrazePixelProps {
  currentUser: CurrentUser
  callback?: (appBoy: { [key: string]: any }) => void
}

const CsrOnlyStudentBrazePixel = ({ currentUser, callback }: CsrOnlyStudentBrazePixelProps) => {
  const setAppboy = useBrazeStore((state) => state.setAppboy)

  const [currentAppboy, setCurrentAppboy] = useState(null)

  const BRAZE_URL = 'sdk.iad-06.braze.com'
  const BRAZE_WEB_KEY = IS_DEVELOPMENT ? BRAZE_STUDENT_WEB_KEY_QA : BRAZE_STUDENT_WEB_KEY_PROD

  // const BRAZE_URL = "sdk.iad-06.braze.com"
  // const BRAZE_WEB_KEY = BRAZE_STUDENT_WEB_KEY_PROD // for testing push local

  useEffect(() => {
    setAppboy(currentAppboy)
  }, [currentAppboy])

  // https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#server-side-rendering-frameworks
  useEffect(() => {
    if (IS_DEVELOPMENT) return

    import('@braze/web-sdk')
      .then((ab) => {
        const appboy = ab
        // 틴즈에서 브레이즈 제외
        if (appboy) {
          appboy.initialize(BRAZE_WEB_KEY, {
            baseUrl: BRAZE_URL,
            enableLogging: !IS_DEVELOPMENT,
            sessionTimeoutInSeconds: 1800,
            minimumIntervalBetweenTriggerActionsInSeconds: 5,
            manageServiceWorkerExternally: true,
            allowUserSuppliedJavascript: true,
          })

          if (appboy.isPushSupported()) {
            appboy.requestPushPermission()
          }
          appboy.automaticallyShowInAppMessages()

          if (currentUser) {
            appboy.changeUser(`${currentUser.id}`)
          }

          appboy.openSession() // new session or continue session
          setCurrentAppboy(appboy)
          if (callback && typeof callback === 'function') {
            callback(appboy)
          }
        }
      })
      .then()
  }, [])

  return <></>
}

export default CsrOnlyStudentBrazePixel
